module.exports = __webpack_public_path__ + "img/b1 (1).b920f06b.png";